export default (params) => ({
  trigger: {
    name: 'advice_bottom_page.select_article',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      article_link_title: {
        type: 'string',
      },
      article_url: {
        type: 'string',
      },
      article_id: {
        type: 'string',
      },
      has_video: {
        type: 'boolean',
      },
    },
    event: {
      name: 'select_article',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
